// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import login from './page/login'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
// eslint-disable-next-line no-unused-vars
import JSEncrypt from 'jsencrypt/bin/jsencrypt'
require('./assets/css/style.css')
Vue.use(ElementUI)
Vue.use(router)
Vue.prototype.$axios = axios
Vue.prototype.url = process.env.url
// axios.defaults.baseURL = 'https://wd2468178309upkmpi.wilddogio.com'
// axios.defaults.baseURL = 'http://192.168.4.163:8003/api/oauth/v1/login'
// axios.defaults.headers.common['token'] = "f4c902c9ae5a2a9d8f84868ad064e706"
// axios.defaults.headers.post["Content-type"] = "application/json"
Vue.component('login', login)
Vue.config.productionTip = false

Vue.prototype.$conf = async function () {
  return await axios.get(this.url + '/api/studyroom/v1/sysSetting/itemconfig').then(({data}) => {
    let conf = {
      isValid: true
    }
    for (let v of data) {
      switch (v.id) {
        case 65:
          conf.title = v.settingValue
          break
        case 407:
          conf.mainImg = v.settingValue
          break
        case 408:
          conf.notice = v.settingValue
          break
        default:
          break
      }
    }
    return {data: conf}
  }).catch(() => {
    // 不存在配置则返回默认数据
    return {
      data: {
        title: '统一登录平台',
        mainImg: 'static/img/logo_login.png',
        notice: '通知：现已开放预约次日研讨间，请知悉。',
        isValid: true
      }
    }
  })
}

// router.beforeEach((to, from, next) => {
//   //NProgress.start();
//   if (to.path == '/login') {
//     sessionStorage.removeItem('user');
//   }
//   let user = JSON.parse(sessionStorage.getItem('user'));
//   if (!user && to.path != '/login') {
//     next({ path: '/login' })
//   } else {
//     next()
//     this.$router.push({path:'admin'})
//   }
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js